export default "{{setName(displayItem)}}\n"